import type { KidneyStatus, PrimaryGoal } from '../../types/onboarding'

/** organic-v2: the app's primary_goal marks (constants/onboarding.ts). */
export const PRIMARY_GOAL_V2_ICONS: Record<PrimaryGoal, string> = {
  manage_ckd: 'goal-manage-ckd',
  slow_progression: 'goal-slow-progression',
  dialysis_support: 'kidney-dialysis',
  post_transplant: 'kidney-transplant',
  kidney_stones: 'kidney-stones',
  caregiver: 'goal-caregiver',
  general_health: 'goal-general-health',
  exploring: 'goal-just-exploring',
}

/** organic-v2: the app's kidney-status marks (constants/kidney.ts KIDNEY_STATUS_META). */
export const KIDNEY_STATUS_V2_ICONS: Record<KidneyStatus, string> = {
  stage_1: 'kidney-stage-1',
  stage_2: 'kidney-stage-2',
  stage_3a: 'kidney-stage-3a',
  stage_3b: 'kidney-stage-3b',
  stage_4: 'kidney-stage-4',
  stage_5: 'kidney-stage-5',
  on_dialysis: 'kidney-dialysis',
  kidney_stones: 'kidney-stones',
  no_diagnosis: 'kidney-prevention',
  not_sure: 'kidney-not-sure',
}
